import React, { useState, useMemo, useEffect } from 'react';
import intl from 'react-intl-universal';
import { Button, MenuItem } from '@blueprintjs/core';
import { Select } from '@blueprintjs/select';
import { FormattedMessage as T } from '../FormattedMessage';
import classNames from 'classnames';
import { CLASSES } from '@/constants/classes';

export function ListSelect({
  buttonProps,
  defaultText,
  noResultsText = <T id="no_results" />,
  isLoading = false,
  textProp,
  labelProp,

  selectedItem,
  selectedItemProp = 'id',

  initialSelectedItem,
  onItemSelect,
  disabled = false,
  ...selectProps
}: any) {
  const selectedItemObj = useMemo(
    () =>
      selectProps.items.find((i: any) => i[selectedItemProp] === selectedItem),
    [selectProps.items, selectedItemProp, selectedItem],
  );

  const selectedInitialItem = useMemo(
    () =>
      selectProps.items.find(
        (i: any) => i[selectedItemProp] === initialSelectedItem,
      ),
    [initialSelectedItem],
  );

  const [currentItem, setCurrentItem] = useState(
    (initialSelectedItem && selectedInitialItem) || null,
  );

  useEffect(() => {
    if (selectedItemObj) {
      setCurrentItem(selectedItemObj);
    }
  }, [selectedItemObj, setCurrentItem]);

  const noResults = isLoading ? (
    'loading'
  ) : (
    <MenuItem disabled={true} text={noResultsText} />
  );

  const itemRenderer = (item: any, { handleClick, modifiers, query }: any) => {
    return (
      <MenuItem
        text={item[textProp]}
        key={item[selectedItemProp]}
        label={item[labelProp]}
        onClick={handleClick}
      />
    );
  };

  const handleItemSelect = (_item: any) => {
    setCurrentItem(_item);
    onItemSelect && onItemSelect(_item);
  };

  // Filters accounts types items.
  const filterItems = (query: any, item: any, _index: any, exactMatch: any) => {
    const normalizedTitle = item[textProp].toLowerCase();
    const normalizedQuery = query.toLowerCase();

    if (exactMatch) {
      return normalizedTitle === normalizedQuery;
    } else {
      return normalizedTitle.indexOf(normalizedQuery) >= 0;
    }
  };

  return (
    <Select
      itemRenderer={itemRenderer}
      onItemSelect={handleItemSelect}
      itemPredicate={filterItems}
      {...selectProps}
      // Le champ de recherche du popover garde sinon le placeholder anglais
      // par défaut de Blueprint (« Filter... ») dans une UI française.
      inputProps={{
        placeholder: intl.get('search'),
        ...(selectProps.inputProps || {}),
      }}
      noResults={noResults}
      disabled={disabled}
      className={classNames(
        CLASSES.FORM_GROUP_LIST_SELECT,
        selectProps.className,
      )}
    >
      <Button
        text={currentItem ? currentItem[textProp] : defaultText}
        loading={isLoading}
        disabled={disabled}
        {...buttonProps}
        fill={true}
      />
    </Select>
  );
}
